import UserStore from "../stores/UserStore";

export default {
    getPublisher(params) {
        let path = process.env.apiPath + '/publisher/publisher.get';
        params = params || 'publisher.account,publisher.payment_details,publisher.rank,publisher_payment_details.created_at,publisher_payment_details.updated_at,publisher.subscribed,publisher.contact';
        return this.makeRequest(path, params);
    },

    getPublisherRanks() {
        let path = process.env.apiPath + '/publisher/publisher.getPublisherRanks';
        return this.makeRequest(path);
    },

    editPublisher(params) {
        let path = process.env.apiPath + '/publisher/publisher.edit';
        params = params || '';
        return this.makeRequest(path, params);
    },

    getReport(params) {
        let path = process.env.apiPath + '/publisher/report.get';
        params = params || {};
        // params.timezone = UserStore.getTimeZone();
        return this.makeRequest(path, params);
    },

    getReportByDay(params) {
        let path = process.env.apiPath + '/publisher/report-by-day.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getReportByCountry(params) {
        let path = process.env.apiPath + '/publisher/report-by-country.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getReportByUTM(params) {
        let path = process.env.apiPath + '/publisher/report-by-utm.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getReportByReactivation(params) {
        let path = process.env.apiPath + '/publisher/report-by-reactivation.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getReportByCreative(params) {
        let path = process.env.apiPath + '/publisher/report-by-creative.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getReportByReferer(params) {
        let path = process.env.apiPath + '/publisher/report-by-referer.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getReportByReferral(params) {
        let path = process.env.apiPath + '/publisher/report-by-referral.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchPayouts(params) {
        let path = process.env.apiPath + '/publisher/publisherPayouts.search';
        params = params || {};
        params.fields = params.fields || 'publisher_payout.created_at,publisher_payout.created_at_formatted,publisher_payout.sum_original,publisher_payout.payment_method_details,publisher_payout.fee,publisher_payout.comment,publisher_payout.from_dt';
        return this.makeRequest(path, params);
    },

    searchAdvertisers(params) {
        let path = process.env.apiPath + '/publisher/advertisers.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchPeriods(params) {
        let path = process.env.apiPath + '/publisher/periods.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchGoalEntries(params) {
        let path = process.env.apiPath + '/publisher/goalEntries.search';
        params = params || {};
        params.fields = 'goal_entry.creative_types,goal_entry.conversion_cap,goal_entry.offer,goal_entry.goal,goal_entry.access_granted,offer.advertiser,offer.locales,offer.default_link,offer.is_referral,goal.offer,offer.image,goal.description,goal.traffic_restrictions,goal_entry.status';
        return this.makeRequest(path, params);
    },

    searchGoalActions(params) {
        let path = process.env.apiPath + '/publisher/goalActions.search';
        params = params || {};
        params.fields = params.fields || 'goal_action.goal,goal_action.commission_contract,goal.offer,action.offer,goal_action.sub_goal_action,goal_action.sub_goal_action_dictionary';
        return this.makeRequest(path, params);
    },

    searchOffers(params) {
        let path = process.env.apiPath + '/publisher/offers.search';
        params = params || {};
        params.fields = 'offer.advertiser,offer.description,offer.default_link,offer.locales,link.url,link.selfie_link,offer.image,offer.tds_domain,offer.landings_domain,offer.image,offer.tds_domain';
        return this.makeRequest(path, params);
    },

    searchUtmMedium(params) {
        let path = process.env.apiPath + '/publisher/utm.search';
        params = params || {};
        params.type = 'UtmMedium';
        return this.makeRequest(path, params);
    },

    searchUtmSource(params) {
        let path = process.env.apiPath + '/publisher/utm.search';
        params = params || {};
        params.type = 'UtmSource';
        return this.makeRequest(path, params);
    },

    searchUtmCampaign(params) {
        let path = process.env.apiPath + '/publisher/utm.search';
        params = params || {};
        params.type = 'UtmCampaign';
        return this.makeRequest(path, params);
    },

    searchUtmTerm(params) {
        let path = process.env.apiPath + '/publisher/utm.search';
        params = params || {};
        params.type = 'UtmTerm';
        return this.makeRequest(path, params);
    },

    searchUtmContent(params) {
        let path = process.env.apiPath + '/publisher/utm.search';
        params = params || {};
        params.type = 'UtmContent';
        return this.makeRequest(path, params);
    },

    searchReactivationUnactivePeriod(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'UnactivePeriod';
        return this.makeRequest(path, params);
    },

    searchReactivationParam2(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'Param2';
        return this.makeRequest(path, params);
    },

    searchReactivationUtmMedium(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'UtmMedium';
        return this.makeRequest(path, params);
    },

    searchReactivationUtmSource(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'UtmSource';
        return this.makeRequest(path, params);
    },

    searchReactivationUtmCampaign(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'UtmCampaign';
        return this.makeRequest(path, params);
    },

    searchReactivationUtmTerm(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'UtmTerm';
        return this.makeRequest(path, params);
    },

    searchReactivationUtmContent(params) {
        let path = process.env.apiPath + '/publisher/utm.reactivation.search';
        params = params || {};
        params.type = 'UtmContent';
        return this.makeRequest(path, params);
    },

    searchCreativeType(params) {
        let path = process.env.apiPath + '/publisher/creativeType.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeLink(params) {
        let path = process.env.apiPath + '/publisher/creativeLink.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeContainer(params) {
        let path = process.env.apiPath + '/publisher/creativeContainer.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeBanner(params) {
        let path = process.env.apiPath + '/publisher/creativeBanner.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeLanding(params) {
        let path = process.env.apiPath + '/publisher/creativeLanding.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativePromoCode(params) {
        let path = process.env.apiPath + '/publisher/creativePromoCode.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchLinks(params) {
        let path = process.env.apiPath + '/publisher/links.search';
        params = params || {};
        params.fields = 'link.url,link.offer,link.default,link.selfie_link,link.locales,offer.advertiser,offer.is_referral,offer.locales,link.image,link.thumbnail';
        return this.makeRequest(path, params);
    },

    searchGoals(params) {
        let path = process.env.apiPath + '/publisher/goals.search';
        params = params || {};
        params.fields = 'goal.offer,offer.advertiser,offer.default_link';
        return this.makeRequest(path, params);
    },

    searchCountries(params) {
        let path = process.env.apiPath + '/publisher/countries.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchReferrers(params) {
        let path = process.env.apiPath + '/publisher/referrers.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchReferrals(params) {
        let path = process.env.apiPath + '/publisher/referrals.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchOffersReferrer(params) {
        let path = process.env.apiPath + '/publisher/offers.referrer.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchAdvertisersReferrer(params) {
        let path = process.env.apiPath + '/publisher/advertisers.referrer.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchAccountEntries(params) {
        let path = process.env.apiPath + '/publisher/publisherAccountEntries.search';
        params = params || {};
        params.fields = 'publisher_account_entry.currency_ratio,publisher_account_entry_source.parameters,currency_ratio.rates';
        return this.makeRequest(path, params);
    },

    convertCurrentCurrency(params) {
        let path = process.env.apiPath + '/publisher/publisherAccount.convert';
        params = params || '';
        return this.makeRequest(path, params);
    },

    testPostbacks(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.test';
        params = params || '';
        return this.makeRequest(path, params);
    },

    searchConversions(params) {
        let path = process.env.apiPath + '/publisher/conversions.search';
        params = params || {};
        // params.timezone = UserStore.getTimeZone(); // TODO
        params.fields = 'conversion.adv_cid,conversion.currency_ratio,conversion.track,currency_ratio.rates,commission.contract,commission.sale_sum,commission.promotion_personal_percent,commission.promotion_per_lead,commission.promotion_per_sale,track.request,track.created_at,track_request.region,track_request.ip,track_request.device';
        return this.makeRequest(path, params);
    },

    searchConversionTotalRows(params) {
        let path = process.env.apiPath + '/publisher/conversions.totalRows';
        params = params || {};
        // params.timezone = UserStore.getTimeZone(); // TODO

        return this.makeRequest(path, params);
    },

    searchFinanceOperations(params) {
        let path = process.env.apiPath + '/publisher/financeOperations.search';
        params = params || {};
        params.fields = '';
        return this.makeRequest(path, params);
    },

    getContactTypes() {
        let path = process.env.apiPath + '/publisher/publisher.getContactTypes';
        return this.makeRequest(path);
    },

    getTimezonesList() {
        let path = process.env.apiPath + '/publisher/publisher.getTimezonesList';
        return this.makeRequest(path);
    },

    getNotification() {
        let path = process.env.apiPath + '/publisher/notification.get';
        return this.makeRequest(path);
    },

    getAggregationInfo() {
        let path = process.env.apiPath + '/publisher/aggregationInfo.get';
        return this.makeRequest(path);
    },

    getConversionUserInfo(params) {
        let path = process.env.apiPath + '/publisher/conversionUserInfo.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    saveViewNotification(params) {
        let path = process.env.apiPath + '/publisher/notification.saveView';
        return this.makeRequest(path, params);
    },

    searchInfoDocs(params) {
        let path = process.env.apiPath + '/publisher/promo.search';
        return this.makeRequest(path, params);
    },

    saveLinkPresets(params) {
        let path = process.env.apiPath + '/publisher/links.savePresets';
        params = params || {};
        return this.makeRequest(path, params);
    },

    savePromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.save';
        params = params || {};
        return this.makeRequest(path, params);
    },

    validatePromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.validate';
        params = params || {};
        return this.makeRequest(path, params);
    },

    editPromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.edit';
        params = params || {};
        return this.makeRequest(path, params);
    },

    deletePromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.delete';
        params = params || {};
        return this.makeRequest(path, params);
    },

    updateShortUrl(params) {
        let path = process.env.apiPath + '/publisher/short-url.update';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getShortUrl(params) {
        let path = process.env.apiPath + '/publisher/short-url.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getShortenerDomainList(params) {
        let path = process.env.apiPath + '/publisher/shortener-domain-list.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getQRCode(params) {
        let path = process.env.apiPath + '/publisher/qr-code.get';
        params = params || {};
        return this.makeRequest(path, params);
    }
};
